import KeenSlider from 'keen-slider';

const sliderInstances = new WeakMap();

const isMobileView = () => window.innerWidth < 768;

const updateButtonsState = (instance, prevButton, nextButton) => {
  if (!instance || !instance.track || !instance.track.details) {
    return;
  }

  const current = instance.track.details.rel;
  const maxIndex = instance.track.details.maxIdx;
  // On mobile the spacer is slide[0], so the first real slide is index 1
  const minIdx = isMobileView() ? 1 : 0;

  if (prevButton) {
    const isDisabled = current <= minIdx;
    prevButton.disabled = isDisabled;
    prevButton.setAttribute('aria-disabled', String(isDisabled));
  }

  if (nextButton) {
    const isDisabled = current >= maxIndex;
    nextButton.disabled = isDisabled;
    nextButton.setAttribute('aria-disabled', String(isDisabled));
  }
};

const initUpcomingEventsSlider = (root) => {
  if (!root || sliderInstances.has(root)) {
    return;
  }

  const sliderElement = root.querySelector('.keen-slider');
  const sectionRoot = root.closest('.upcoming-events') || root;
  const prevButton = sectionRoot.querySelector('[data-upcoming-events-prev]');
  const nextButton = sectionRoot.querySelector('[data-upcoming-events-next]');

  if (!sliderElement) {
    return;
  }

  const totalSlides = sliderElement.querySelectorAll('.keen-slider__slide').length;

  if (totalSlides <= 1) {
    if (prevButton) {
      prevButton.disabled = true;
      prevButton.setAttribute('aria-disabled', 'true');
    }

    if (nextButton) {
      nextButton.disabled = true;
      nextButton.setAttribute('aria-disabled', 'true');
    }

    return;
  }

  const slider = new KeenSlider(sliderElement, {
    loop: false,
    rubberband: false,
    initial: isMobileView() ? 1 : 0,
    slides: {
      perView: 1.2,
      spacing: 16,
      origin: 'center',
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: {
          perView: 'auto',
          spacing: 20,
          origin: 'center',
        },
      },
      '(min-width: 1200px)': {
        slides: {
          perView: 'auto',
          spacing: 24,
          origin: 'auto',
        },
      },
    },
    created(instance) {
      updateButtonsState(instance, prevButton, nextButton);
    },
    slideChanged(instance) {
      // Prevent landing on the spacer slide (index 0) on mobile
      if (isMobileView() && instance.track.details.rel === 0) {
        instance.moveToIdx(1, true, { duration: 200 });
        return;
      }
      updateButtonsState(instance, prevButton, nextButton);
    },
    updated(instance) {
      updateButtonsState(instance, prevButton, nextButton);
    },
  });

  if (prevButton) {
    prevButton.addEventListener('click', () => slider.prev());
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => slider.next());
  }

  sliderInstances.set(root, slider);
};

const bootstrapUpcomingEventsSliders = () => {
  const sliders = document.querySelectorAll('[data-upcoming-events-slider]');
  if (!sliders.length) {
    return;
  }

  sliders.forEach((sliderRoot) => {
    initUpcomingEventsSlider(sliderRoot);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapUpcomingEventsSliders);
} else {
  bootstrapUpcomingEventsSliders();
}
